import { render, staticRenderFns } from "./ComingEvents.vue?vue&type=template&id=4ff26771&"
import script from "./ComingEvents.vue?vue&type=script&lang=js&"
export * from "./ComingEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports